import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import MinimalDark from "../themes/MinimalDark";
import CrimsonBold from "../themes/CrimsonBold";
import LightBreeze from "../themes/LightBreeze";
import CyberNeon from "../themes/CyberNeon";
import { API_URL } from "../constants/constants";

const themeMap = {
  "minimal-dark": MinimalDark,
  "crimson-bold": CrimsonBold,
  "light-breeze": LightBreeze,
  "cyber-neon": CyberNeon,
};

function PublicProfile() {
  const { username } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/user/profile/${username}`)
      .then((res) => {
        setUser(res.data);
        setLoading(false);
      })
      .catch(() => {
        setUser(null);
        setLoading(false);
      });
  }, [username]);

  if (loading) return <div>Loading...</div>;
  if (!user) return <div>User not found</div>;

  const ThemeComponent = themeMap[user.theme] || MinimalDark;

  return <ThemeComponent user={user} />;
}

export default PublicProfile;
